import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, ParamMap} from '@angular/router';
import {BwEtreeService, UpdateRequest, UpdateRequestService} from '../../generated';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {DatePipe} from '@angular/common';
import {saveAs} from 'file-saver';
import * as _ from 'lodash';
import {Etree} from '../../models/Etree';
import {BaseClientComponent} from '../base-client.component';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';
import {UtilsService} from '../../appSharedModule/services/utils.service';
import {HttpClient} from '@angular/common/http';
import {QuincyEtree} from '../../models/QuincyEtree';
import {Company} from '../../models/company';
import {UserLogged} from '../../models/userLogged';

@Component({
  selector: 'app-quincy-etree-over-view',
  templateUrl: './quincy-etree-over-view.component.html',
  styleUrls: ['./quincy-etree-over-view.component.css']
})
export class QuincyEtreeOverViewComponent extends BaseClientComponent implements OnInit, OnDestroy {

  currentEtree: QuincyEtree;
  currentCompany: Company;
  loggedInUser: UserLogged;
  macUploadForm: UntypedFormGroup;
  bufferPriorityForm: UntypedFormGroup;
  file: File;
  reader: FileReader;
  fileBuffer = null;
  fileLines: string[] = [];
  uploadedMacAddressArray: any = [];
  uploadedMacAddressHeader = '';
  databaseMacAddressArray: any = [];
  databaseMacAddressHeader = '';
  macAddressArray: any = [];
  macAddressHeader = '';
  UPDATE_MAC_ADRESS_TYPE = 'sps.mac_list';
  UPDATE_BUFFER_PRIORITIES_TYPE = 'lcm.buffers';
  csvDatabaseFileToDwonloadBlob: Blob = null;
  csvDatabaseFileToDwonloadName = '';
  bufferDataHeader: string = null;
  loading = true;

  constructor(
    public route: ActivatedRoute,
    public bwEtreeService: BwEtreeService,
    public updateRequestService: UpdateRequestService,
    public formBuilder: UntypedFormBuilder,
    public datePipe: DatePipe,
    public authenticationService: AuthenticationService,
    protected utilsService: UtilsService,
    protected http: HttpClient,
  ) {
    super();
    this.reader = new FileReader();
    this.reader.onload = () => {
      this.fileBuffer = this.reader.result;
      this.fileLines = this.fileBuffer.split('\n');
    };
  }

  ngOnInit() {
    const response$ = this.authenticationService.waitForAuthenticationThenLaunch(() => {
      this.ngOnChanges();
    });
    this.subscriptions.push(response$);
  }

  public ngOnChanges() {
    this.loading = true;
    this.utilsService.lockUi();
    this.uploadedMacAddressArray = [];
    this.loggedInUser = this.authenticationService.userCurrent;
    this.currentCompany = this.loggedInUser.company;
    this.route.paramMap.subscribe((paramMap: ParamMap) => {
      const etreeId = paramMap['params']['id'];
      this.bwEtreeService.getBwEtreeItem(etreeId).subscribe((etree) => {
          if (!etree) {
            this.redirectionToNotFound();
          }
          if (etree.source !== 'MARS') {
            this.redirectionToNotFound();
          }
          this.initForms();
          this.macAddressArray = [];
          this.macAddressHeader = '';
          this.currentEtree = JSON.parse(etree.jsonData) as Etree;
          this.currentEtree.updateRequests = etree.updateRequests;
          this.currentEtree.latestUpdateRequests = etree.latestUpdateRequests;
          if (this.currentEtree.latestUpdateRequests[this.UPDATE_MAC_ADRESS_TYPE]) {
            this.prepareMacTabledata(this.currentEtree.latestUpdateRequests[this.UPDATE_MAC_ADRESS_TYPE]);
          }
          if (this.currentEtree.latestUpdateRequests[this.UPDATE_BUFFER_PRIORITIES_TYPE]) {
            this.prepareBuffersPriorities(this.currentEtree.latestUpdateRequests[this.UPDATE_BUFFER_PRIORITIES_TYPE]);
          }
          this.loading = false;
          this.utilsService.unlockUi();
        }
      );
    });
  }

  public initForms() {
    this.macUploadForm = this.formBuilder.group({
      'macAdresseFile': ['', Validators.required],
    });
    this.bufferPriorityForm = this.formBuilder.group({
      'highPriority': ['8'],
      'lowPriority': ['2', Validators.required],
    });
  }

  public showMacUploadFormErrorMessage(fieldName: string): boolean {
    return !this.macUploadForm.controls[fieldName].valid;
  }

  public downloadMAcListAsCsv() {
    saveAs(this.csvDatabaseFileToDwonloadBlob, this.csvDatabaseFileToDwonloadName);
  }

  public clearMacFileUpload() {
    this.macAddressHeader = this.databaseMacAddressHeader;
    this.macAddressArray = this.databaseMacAddressArray;
    this.uploadedMacAddressArray = [];
    this.uploadedMacAddressHeader = '';
  }

  public uploadMacFile(event) {
    this.uploadedMacAddressArray = [];
    this.file = event.files[0];
    this.reader.readAsText(this.file);
    this.reader.onloadend = () => {
      const csv = this.reader.result as string;
      const allTextLines = csv.split(/\r|\n|\r/);
      const headers = allTextLines[0].split(',');
      for (let i = 0; i < allTextLines.length; i++) {
        const data = allTextLines[i].split(',');
        if (data.length === headers.length && i > 0) {
          const tarr = [];

          for (let j = 0; j < headers.length; j++) {
            tarr.push(data[j]);
          }
          this.uploadedMacAddressArray.push(tarr);
        }
      }
      this.uploadedMacAddressHeader = 'You are about to upload this MAC address list.';
      this.macAddressArray = this.uploadedMacAddressArray;
      this.macAddressHeader = this.uploadedMacAddressHeader;
    };
  }

  public transmitMacFile() {
    const data = [];
    data.push({'sps.mac_list': this.uploadedMacAddressArray});
    const updateRequest = <UpdateRequest>{
      bwEtree: '/api/bw_etrees/' + this.currentEtree.id,
      status: 'sent',
      type: this.UPDATE_MAC_ADRESS_TYPE,
      jsonParams: data[0],
      userId: this.loggedInUser.id,
      username: this.loggedInUser.username,
      company: '/api/companies/' + this.loggedInUser.company.id
    };
    this.updateRequestService.postUpdateRequestCollection(updateRequest).subscribe({
      next: () => {
        this.ngOnInit();
      }, error: () => {
      }
    });
  }

  public showBufferPrioritiesErrorMessage(fieldName: string): boolean {
    return !this.bufferPriorityForm.controls[fieldName].valid;
  }

  public prepareBuffersPriorities(updateRequest: UpdateRequest) {
    const dateSentList = new Date(updateRequest.createdDate);
    const bufferData = updateRequest.jsonParams;
    this.bufferDataHeader = 'Last buffer priorities <b>(';
    this.bufferDataHeader += 'High= ' + bufferData['lcm.buffers']['high'] + ',';
    this.bufferDataHeader += 'Low= ' + bufferData['lcm.buffers']['low'] + ')</b> has been sent to Mckay at: '
      + this.datePipe.transform(dateSentList, 'yyyy/MM/dd H:mm');
    if (updateRequest.status === 'sent') {
      this.bufferDataHeader += ' <span  class="badge badge-info">' + updateRequest.status + '</span>';
    } else if (updateRequest.status === 'configured') {
      this.bufferDataHeader += ' <span  class="badge badge-success">' + updateRequest.status + '</span>';
    } else {
      this.bufferDataHeader += ' <span>' + updateRequest.status + '</span>';
    }
  }

  public saveBufferPriorities() {
    const data = [];
    data.push({
      'lcm.buffers': {
        'high': this.bufferPriorityForm.value.highPriority,
        'low': this.bufferPriorityForm.value.lowPriority
      }
    });
    const updateRequest = <UpdateRequest>{
      bwEtree: '/api/bw_etrees/' + this.currentEtree.id,
      status: 'sent',
      type: this.UPDATE_BUFFER_PRIORITIES_TYPE,
      jsonParams: data[0],
      userId: this.loggedInUser.id,
      username: this.loggedInUser.username,
      company: '/api/companies/' + this.loggedInUser.company.id
    };
    this.updateRequestService.postUpdateRequestCollection(updateRequest).subscribe({
      next: () => {
        this.ngOnInit();
      }, error: () => {
      }
    });
  }

  redirectionToNotFound() {
    location.assign('/#/404');
  }

  createCsvFile() {
    let blobType: any;
    blobType = 'source,destination\n';
    let blocLine = [];
    for (const macAddress of this.currentEtree.macAdresses) {
      blocLine = [String(macAddress['source']).replace(/:/g, '-'),
        String(macAddress['destination']).replace(/:/g, '-')];
      blobType = blobType + blocLine.join(',') + '\n';
      blocLine = [];
    }
    const csv = new Blob([blobType], {
      type: 'text/csv'
    });
    const dateObject = new Date();
    const isoDate = this.datePipe.transform(dateObject, 'yyyyMMdd');
    saveAs(csv, isoDate + '_sps_mac_list.csv');
  }

  private prepareMacTabledata(updateRequest: UpdateRequest) {
    this.macAddressArray = updateRequest.jsonParams['sps.mac_list'];
    const dateSentList = new Date(updateRequest.createdDate);
    if (updateRequest.jiraIssue) {
      this.macAddressHeader = 'This following mac adresses has been sent to Mckay at1: '
        + this.datePipe.transform(dateSentList, 'yyyy/MM/dd H:mm');
      if (updateRequest.status === 'sent') {
        this.macAddressHeader += ' <span  class="badge badge-info">' + updateRequest.status + '</span>';
      } else if (updateRequest.status === 'configured') {
        this.macAddressHeader += ' <span  class="badge badge-success">' + updateRequest.status + '</span>';
      } else {
        this.macAddressHeader += ' <span>' + updateRequest.status + '</span>';
      }
      this.databaseMacAddressHeader = this.macAddressHeader;

    }
    this.databaseMacAddressArray = this.macAddressArray;
    const lineArray = [];
    const csvHeaders = ['Source', 'Destination'];
    const tmpCsvData = _.clone(this.databaseMacAddressArray);
    tmpCsvData.unshift(csvHeaders);
    tmpCsvData.forEach(function (infoArray) {
      const line = infoArray.join(',');
      lineArray.push(line);
    });
    const csvContent = lineArray.join('\n');
    this.csvDatabaseFileToDwonloadBlob = new Blob([csvContent], {
      type: 'text/csv'
    });
    this.csvDatabaseFileToDwonloadName = 'Mac_List' + this.currentEtree.name.split(' ').join('_') + '_'
      + this.datePipe.transform(dateSentList, 'yyyy_MM_dd') + '.csv';

  }
}
